import { X } from "lucide-react";
import { useRef, useState } from "react";
import { Input } from "../ui/input";
import { Badge } from "../ui/badge";
import CustomLabelText from "../CustomLabelText";
import { Label } from "../ui/label";

const EmailChipInput = ({
  label,
  value,
  setValue,
  required = false,
  errors,
}) => {
  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef(null);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      const trimmed = inputValue.trim().replace(/,$/, "");
      if (trimmed && isValidEmail(trimmed)) {
        setValue([...value, trimmed]);
        setInputValue("");
      }
    }
  };

  const removeEmail = (index) => {
    setValue(value.filter((_, i) => i !== index));
  };

  return (
    <div>
      <Label htmlFor={label}>
        <CustomLabelText
          required={required}
          labelText={label}
          errorField={errors}
          className="mb-2"
        />
      </Label>
      <div className="flex flex-wrap gap-2 items-center border rounded-lg p-1 px-2 focus-within:ring-2 focus-within:ring-blue-500">
        {value.map((email, index) => (
          <Badge
            key={index}
            variant="secondary"
            className="flex items-center gap-1 px-2 py-1"
          >
            {email}
            <button
              onClick={() => removeEmail(index)}
              className="ml-1 text-muted-foreground hover:text-destructive"
            >
              <X size={14} />
            </button>
          </Badge>
        ))}
        <Input
          ref={inputRef}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Add email and press Enter"
          className="!border-0 focus:ring-0 w-auto flex-1 min-w-[150px] focus-visible:ring-0"
        />
      </div>
    </div>
  );
};

export default EmailChipInput;
